import { writable } from 'svelte/store';

// The one notification style (same as the CA app). New code: toast(message, 'success' | 'error' | 'info').
export const toasts = writable([]);
let seq = 0;
export const dismissToast = (id) => toasts.update((t) => t.filter((x) => x.id !== id));

export function toast(message, kind = 'info', ms = kind === 'error' ? 6000 : 4000) {
  const id = ++seq;
  const text = message instanceof Error ? message.message : String(message ?? '');
  toasts.update((t) => [...t, { id, message: text, kind }]);
  setTimeout(() => dismissToast(id), ms);
  return id;
}

// Legacy svelte-toast call shape -> kind (see mapping table).
function kindOf(opts = {}) {
  if (opts.type === 'success' || opts.type === 'error') return opts.type;
  const c = opts.classes ?? [];
  if (c.includes('success')) return 'success';
  if (c.includes('error') || c.includes('warn')) return 'error';
  return 'info';
}
toast.push = (message, opts) => toast(message, kindOf(opts));
